core.service('customCSSInjector', [
    function () {
        this.injectCSS = function (customConfig) {

            var injectCSSObject = {};

            if (customConfig.themeMainColor) {
                injectCSSObject['h3, h4'] = {
                    'border-bottom': '1px dashed ' + customConfig.themeMainColor
                };

                injectCSSObject['#sidebar'] = {
                    ' .nav > li' :{
                        'a': {
                            'color': customConfig.themeMainColor
                        },
                        '&.active': {
                            'a': {
                                'border-left': '10px solid ' + customConfig.themeMainColor
                            },
                            'ul li': {
                                'a': {
                                    'border-left': '10px solid ' + customConfig.themeMainColor,
                                    '&:hover': {
                                        'border-left': '10px solid ' + customConfig.themeMainColor
                                    }
                                }
                            }
                        }

                    }
                };

                injectCSSObject['#menu'] = {
                    '&.navbar-default': {
                        'background': customConfig.themeMainColor + ' !important',
                        '.navbar-nav': {
                            '> li': {
                                '&.active': {
                                    '> a': {
                                        'color': customConfig.themeMainColor,
                                        '&:hover': {
                                            'color': customConfig.themeMainColor
                                        }
                                    }
                                },
                                'a': {
                                    '&:hover': {
                                        'color': customConfig.themeMainColor
                                    }
                                }
                            }
                        }
                    }
                };

                injectCSSObject['.bootstrap-select'] = {
                    '.dropdown-menu > li': {
                        '> a:focus': {
                            'background': customConfig.themeMainColor
                        },
                        '> a:hover': {
                            'background': customConfig.themeMainColor
                        },
                        '> a:active': {
                            'background': customConfig.themeMainColor
                        }
                    }
                };

            }

            $.injectCSS(injectCSSObject, { containerName: 'customStyles' });
        };
    }
]);
